export default "__VITE_ASSET__CDIkY9KV__"